import { render, staticRenderFns } from "./shopping.vue?vue&type=template&id=cd0eef04&scoped=true&"
import script from "./shopping.vue?vue&type=script&lang=js&"
export * from "./shopping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd0eef04",
  null
  
)

export default component.exports